import { ApiTypes, PaginationTypes } from '@mode/shared/contract-common';
import { SpaceDomain } from '@mode/shared/contract-common';

import { AccountResource } from '../..';
import { getEmbedded, getForm, getLink, getEmbeddedCollection, getHref } from '@mode/shared/util-halogen';
import {
  SpaceEntitlementResource,
  SpacePermissionsSearchResultResource,
  SpaceResource,
} from '../spaces/spaces-response.types';

export function toSpace(resource: SpaceResource): SpaceDomain.Space {
  return {
    canDestroyEntitlements: !!resource._forms?.['destroy_entitlements'],
    defaultAccessLevel: resource.default_access_level,
    token: resource.token,
  };
}

export function toEntitlement(resource: SpaceEntitlementResource): SpaceDomain.Entitlement {
  let entitlementWebLink = getLink(resource, 'web_user_group_members') as ApiTypes.HalLink;

  const accessorAccount = getEmbedded<AccountResource>(resource, 'accessor');
  return {
    accessor: {
      avatar: (accessorAccount && (accessorAccount.avatar as any)) || {},
      name: (accessorAccount && accessorAccount.name) || '',
      token: (accessorAccount && accessorAccount.token) || '',
      type: resource.accessor_type,
      webLink: (entitlementWebLink && entitlementWebLink.href) || '',
    },
    action: resource.action,
    token: resource.token,
    groupType: resource.group_type,
  };
}

export function toPermissionsSearchResult(
  resource: SpacePermissionsSearchResultResource
): SpaceDomain.PermissionsSearchResult {
  const entitlementWebLink = getLink(resource, 'web_user_group_members') as ApiTypes.HalLink;

  return {
    avatar: resource.avatar,
    name: resource.name,
    token: resource.token,
    type: resource.type,
    webLink: (entitlementWebLink && entitlementWebLink.href) || '',
  };
}

export function toCollectionsWithPaginatorAndQuery(
  resource: ApiTypes.ModeHalResource
): SpaceDomain.CollectionsSearchResult {
  let spaces: SpaceDomain.SpacePaginated[] = [];

  getEmbeddedCollection<SpaceResource>(resource, 'spaces')?.forEach((space: SpaceResource) => {
    spaces.push({
      id: space['id'],
      token: space.token,
      name: space.name,
      description: space.description,
      default_access_level: space.default_access_level,
      space_type: space.space_type,
      editForm: getForm(space, 'edit'),
      detail: getEmbedded(space, 'detail'),
      creator: getEmbedded(space, 'creator'),
      webLink: getHref(space, 'web') as string,
      membershipLink: getHref(space, 'user_space_membership') as string,
    });
  });
  return {
    pagination: resource['pagination'] as PaginationTypes.Pagination,
    spaces: spaces,
  };
}
